// store/historySlice.js
import { createSlice } from "@reduxjs/toolkit";

const historySlice = createSlice({
  name: "history",
  initialState: { snapshots: [], loading: false },
  reducers: {
    setSnapshots(state, action) {
      state.snapshots = action.payload;
    },
    setLoading(state, action) {
      state.loading = action.payload;
    },
  },
});

export const { setSnapshots, setLoading } = historySlice.actions;
export default historySlice.reducer;